import React from "react";
import "./tncdmt.css";
const Tncdmt = () => {
  return (
    <>
      <section class="OP_BannerPRIVACY clearfix">
        <div class="container-fluid">
          <h2>
            Grahak Seva Kendra
            <span>Terms & Conditions</span>
          </h2>
        </div>
      </section>

      <section class="space contact_us_bgcol pb-5">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <p class="service-content">
                <b>DMT EMPIRE INDIA PRIVATE LIMITED (“DMT”)</b> is a FinTech
                platform delivering multiple services to Individuals and
                Businesses. DMT is authorized by multiple banks to act as a
                Corporate Business Correspondent and appoint Agent Business
                Correspondents to deliver mainstream financial and other citizen
                services to the Customers under the guidelines issued by the RBI
                or Other Regulatory authorities of the government of India. DMT
                is engaged in the business of distribution of various services
                like Travel booking Services (Flight, Hotel, Bus and Train
                Ticket Bookings) Financial Inclusion (Domestic Money Transfer,
                Nepal Money Transfer, AEPS, Micro ATM, and M-POS), Insurance
                (Life, Health and General Insurance), Utility Payments (Mobile &
                DTH Prepaid Recharge and Bill Payments), and many more services.
              </p>
              <p class="service-content">
                <b>“DMT Grahak Seva Kendra(s)”</b> shall mean and include the
                Users registered on the DMT Platform who are authorized by DMT
                and the Bank to operate as ABC(s) under the above-mentioned
                guidelines for providing banking and citizen services envisaged
                in these DMT Grahak Seva Kendra Terms and Conditions.
              </p>
              <p>
                Subject to the compliance of applicable regulations and basis
                the representations and the affirmations given by the DMT Grahak
                Seva Kendra about it having the requisite capability to provide
                the services further and to carry out various other activities
                as mutually agreed to between the DMT Grahak Seva Kendra and the
                Company, the DMT Grahak Seva Kendra is desirous of facilitating
                the sale of services of the Bank(s) and Other service
                provider(s). These DMT Grahak Seva Kendra Terms and Conditions
                (“DMT Grahak Seva Kendra Terms and Conditions”) as set out below
                are in addition to the Terms and Conditions as set out above and
                apply to all the DMT Grahak Seva Kendra registered on the DMT
                Platform.
              </p>
              <p>
                <b>DMT GRAHAK SEVA KENDRA OBLIGATIONS AND DUTIES </b>
              </p>
              <ul style={{ listStyleType: "lower-roman" }}>
                <li>
                  The DMT Grahak Seva Kendra shall only undertake the activities
                  following all the applicable Terms, relevant regulations, and
                  standard operating procedures issued by the Bank or the
                  Regulators from time to time.
                </li>
                <li>
                  The DMT Grahak Seva Kendra shall take an appropriate insurance
                  policy to protect itself from any business impediments,
                  financial and non-financial risks.
                </li>
                <li>
                  The DMT Grahak Seva Kendra shall operate at its own cost as
                  may be required by the Company or the Bank to effectively
                  deliver the services to the Customers.
                </li>
                <li>
                  The DMT Grahak Seva Kendra shall ensure that any additional
                  resource(s) engaged by the DMT Grahak Seva Kendra, subject to
                  prior written approval from the Company, are selected through
                  a process found suitable by the Company for providing the
                  services in a timely and efficient manner.
                </li>
                <li>
                  The DMT Grahak Seva Kendra shall be solely responsible for
                  compliance with all applicable labor laws concerning the
                  personnel it employs along with the associated costs. DMT will
                  not have any right, obligation, or responsibility whatsoever
                  to control, supervise or manage the DMT Grahak Seva Kendra’s
                  employees, agents, or independent contractors.
                </li>
                <li>
                  The DMT Grahak Seva Kendra may utilize any third-party
                  software other than the Software for providing the Services
                  only after prior written permission of the Company. The DMT
                  Grahak Seva Kendra shall ensure that such third-party Software
                  is validly licensed, procured, and installed. It shall ensure
                  that the use of third-party Software shall not affect or
                  damage DMT’s Software.
                </li>
                <li>
                  The DMT Grahak Seva Kendra shall act prudently following these
                  Terms and Conditions and shall exercise all due diligence in
                  carrying out its duties and obligations under these Terms and
                  Conditions. The DMT Grahak Seva Kendra agrees that they will
                  preserve the data following the legal/regulatory obligations
                  of the Company and as required under various circulars,
                  guidelines, notifications, etc. issued by the Bank or other
                  regulatory authorities.
                </li>
                <li>
                  The DMT Grahak Seva Kendra shall not exercise any lien or
                  right to set-off or appropriation on any of the assets,
                  properties, documents, instruments, or material belonging to
                  the Company and/or the Customers and/or non-Customers in the
                  custody of the DMT Grahak Seva Kendra for any amount due or
                  claimed to be due by the DMT Grahak Seva Kendra from the Bank.
                </li>
                <li>
                  The DMT Grahak Seva Kendra shall promptly provide the details
                  provided by the Company indicating the charges (if any) for
                  the Services rendered to each Customer. The DMT Grahak Seva
                  Kendra shall ensure that the charges for offering Services are
                  communicated to the Customer before rendering the services.
                </li>
                <li>
                  The DMT Grahak Seva Kendra shall not charge any fee from the
                  Customer either directly or indirectly or on behalf of the
                  Company over and above the fee specified by the Company from
                  time to time.
                </li>
                <li>
                  The DMT Grahak Seva Kendra undertakes to perform the Services
                  following the instructions provided by the Company from time
                  to time.
                </li>
                <li>
                  The DMT Grahak Seva Kendra undertakes that any software or
                  hardware used by the DMT Grahak Seva Kendra shall comply with
                  the industry standards and will be updated regularly.
                </li>
                <li>
                  The DMT Grahak Seva Kendra shall immediately notify the
                  Company of any breach of security and leakage of confidential
                  information. In such eventualities, the DMT Grahak Seva Kendra
                  shall be liable for all the damages and repercussions.
                </li>
                <li>
                  The DMT Grahak Seva Kendra shall communicate this policy to
                  each Customer and shall notify the Company within the
                  specified time of any claims/complaints/grievances made by the
                  Customers.
                </li>
                <li>
                  The DMT Grahak Seva Kendra undertakes that any Customer
                  information taken shall be strictly protected as per the Terms
                  and Conditions and the DMT Grahak Seva Kendra would not source
                  any other personal sensitive information from the Customers.
                </li>
                <li>
                  In no event shall the DMT Grahak Seva Kendra indulge or enter
                  into any financial transaction with any of the DMT employees,
                  associates, agents, and/or personnel. DMT shall not be liable
                  for any damages, losses (direct or indirect) whatsoever caused
                  to the DMT Grahak Seva Kendra arising out of such
                  transactions.
                </li>
                <li>
                  The DMT Grahak Seva Kendra shall treat all the Customers with
                  dignity and respect and shall not resort to any kind of
                  intimidation or harassment, either verbal or physical against
                  any person.
                </li>
                <li>
                  If any legal proceeding is instituted by any Customer, the DMT
                  Grahak Seva Kendra shall immediately intimate the same to the
                  Company and provide all documents and information to enable
                  the Company to take appropriate action. The Company shall not
                  be liable for any dispute arising between the DMT Grahak Seva
                  Kendra and any other entity / third party. The DMT Grahak Seva
                  Kendra shall not make any representation to the Customers or
                  otherwise give any warranties other than those contained in
                  the standard terms and conditions laid down by the Company.
                </li>
              </ul>
              <p class="service-content">
                <b>ADVANCEMENT OF E-VALUE/WALLET BALANCE</b>
              </p>
              <p class="service-content">
                The Parties hereby agree that the following procedure for the
                advancement of e-value by Company to DMT GRAHAK SEVA KENDRA
                shall be adopted for the provision of Services:
              </p>
              <ul>
                <li>
                  DMT GRAHAK SEVA KENDRA shall deposit in advance into the bank
                  account of the Company as directed by the Company for
                  obtaining the e-value required by it. Such deposit shall be
                  made by DMT Grahak Seva Kendra through Cash and electronic
                  transfer by using own/company’s Debit/Credit/Net banking only.
                </li>
                <li>
                  DMT GRAHAK SEVA KENDRA shall, immediately after depositing as
                  per (a) above, inform Company through any of the channels made
                  available by the Company such as e-mail or web application and
                  in the prescribed format and specified message destination
                  points setting out the details of the deposit made.
                </li>
                <li>
                  DMT GRAHAK SEVA KENDRA is NOT ALLOWED to get the Value by
                  using third-party deposits/Transfers/ credit card/debit cards
                  and internet banking etc. The DMT GRAHAK SEVA KENDRA can use
                  own/Company details only to avail value in the wallet. In case
                  of any Chargeback, the DMT GRAHAK SEVA KENDRA is solely
                  responsible and liable to bear the losses.
                </li>
                <li>
                  In case of any discrepancy, DMT GRAHAK SEVA KENDRA shall
                  deposit the discrepant amount in the Company’s bank account
                  immediately and not later than within (3) three bank working
                  hours of receipt of such intimation from the Company.
                </li>
              </ul>
              <p class="service-content">
                <b>CASH MANAGEMENT</b>
              </p>
              <p class="service-content">
                DMT shall from time to time authorize certain DMT Grahak Seva
                Kendra s for cash management activities and to further extend
                the reach of banking services to the Customers for greater
                financial inclusion. Such DMT Grahak Seva Kendras shall:
              </p>
              <ul>
                <li>
                  Collect and/or dispense cash at other DMT Grahak Seva Kendra
                  outlets in the assigned territory to ensure uninterrupted
                  delivery of banking and citizen services to the Customers as
                  per the mutually agreed terms.
                </li>
                <li>
                  Confirms that it assumes all the risks associated with cash
                  logistics and shall take an appropriate insurance policy to
                  protect itself from any business impediments, financial and
                  non-financial risks.
                </li>
                <li>
                  Be solely responsible for providing genuine currency to all
                  the DMT Grahak Seva Kendra s and hence to the Customers
                  towards the Transactions performed and the Company shall not
                  assume any responsibility in this regard.
                </li>
                <li>
                  Ensure that the credit or debit against the cash collected or
                  dispensed to the other DMT Grahak Seva Kendra (s) happens on
                  an immediate basis at the time of handing over the cash.
                </li>
              </ul>
              <p class="service-content">
                <b>SETTLEMENT </b>
              </p>
              <p class="service-content">
                The payment mechanism for settlement of the fee payable by the
                DMT Grahak Seva Kendra or the Company as applicable shall be as
                follows:
              </p>
              <ul>
                <li>
                  The Company shall make available to the DMT Grahak Seva Kendra
                  a report in electronic form setting forth the following
                  information relating to each Transaction: The Transaction
                  amount, date and time of the Transaction, Transaction serial
                  number, Service Provider identification, and response code
                  ("MIS"). The MIS shall be made available to the DMT Grahak
                  Seva Kendra via an online portal. The format and controls on
                  the portal and process are provided by the Company and updated
                  from time to time.
                </li>
                <li>
                  The DMT Grahak Seva Kendra shall maintain sufficient
                  credit/balance with the Company to enable each Transaction to
                  be carried out smoothly. The Company reserves the right to
                  decline any Transactions done over and above the balance of
                  DMT Grahak Seva Kendra available with the Company.
                </li>
                <li>
                  The DMT Grahak Seva Kendra hereto agrees that any payment
                  instructions for Transactions accepted by the DMT Grahak Seva
                  Kendra as per the terms hereof which are subsequently disputed
                  due to (a) the authorization by the DMT Grahak Seva Kendra of
                  any Transaction with an amount exceeding the DMT Grahak Seva
                  Kendra’s account balance or credit limit, or (b) the
                  authorization by the DMT Grahak Seva Kendra of a fraudulent
                  Transaction, shall always be the liability and responsibility
                  of DMT Grahak Seva Kendra.
                </li>
                <li>
                  The DMT Grahak Seva Kendra hereby acknowledges and agrees that
                  DMT is a facilitator for payment processing services which are
                  requested and authorized by DMT Grahak Seva Kendra and DMT
                  shall not be responsible for any unauthorized transaction done
                  by any person including third party and amounting to
                  infringement of another’s rights or any chargebacks claimed by
                  the Customers. It will be the responsibility of DMT Grahak
                  Seva Kendra to ensure due protection while transacting online
                  or otherwise. DMT will assist the DMT Grahak Seva Kendra in
                  settling any queries related to the Services that arise
                  between the DMT Grahak Seva Kendra and its Customers and any
                  other DMT Grahak Seva Kendra. However, DMT shall bear no
                  responsibility concerning the dispute or query related to the
                  payment made by the Customers to the DMT Grahak Seva Kendra.
                </li>
                <li>
                  On the receipt of the Chargeback from the customer, DMT Grahak
                  Seva Kendra shall be notified by the Company. The DMT Grahak
                  Seva Kendra hall is entitled to furnish documents and
                  information about the Transaction associated with the
                  Chargeback within one (1) working day or such other period as
                  specified by the bank whichever is higher. The DMT Grahak Seva
                  Kendra agrees and acknowledges that (i) if the DMT Grahak Seva
                  Kendra is unable to furnish Chargeback Documents (ii) the bank
                  is not satisfied with the Chargeback documents furnished by
                  the DMT Grahak Seva Kendra, then the bank shall be entitled to
                  order the DMT to affect a reversal of the debit of the
                  Chargeback Amount associated with the Chargeback such that the
                  said chargeback amount is credited to the Customer’s Payment
                  Instrument.
                </li>
              </ul>
              <p class="service-content">
                <b>DATA SECURITY AND STORAGE </b>
              </p>
              <p class="service-content">
                The DMT Grahak Seva Kendra shall comply with the provisions
                contained in the Information Technology Act, 2000 and the
                statutory rules framed thereunder, from time to time, in so far
                as the same has applied to its operations under all these Terms
                and Conditions, and also with all other Laws, rules and
                regulations, whether already in force or which may be enacted
                from time to time, about data security and management, data
                storage, sharing and data protection, and various rules,
                regulation, and provisions as may be applicable, as and when the
                same is enacted into law and comes into force, and shall ensure
                the same level of compliance by all its employees.
              </p>
              <p class="service-content">
                The DMT Grahak Seva Kendra confirms and certifies that it will
                never engage in any acts that violate any laws and regulations.
                It shall also ensure that the financial data or any other
                information of the Customers received by the DMT Grahak Seva
                Kendra are stored in a system only in India. This data shall
                include full end-to-end transaction details/information
                collected/carried/processed as part of the message/payment
                instructions.
              </p>
              <p class="service-content">
                <b>TERMINATION </b>
              </p>
              <p class="service-content">
                The DMT Grahak Seva Kendra agrees that DMT, in its sole
                discretion, for any or no reason, and without penalty, may
                suspend or terminate the account (or any part thereof) or the
                use of the DMT Platform. DMT may also in its sole discretion and
                at any time discontinue providing access to the DMT Services, or
                any part thereof, with or without notice. DMT Grahak Seva Kendra
                agrees that any termination of the access to the DMT platform
                may be effected without prior notice, and DMT Grahak Seva Kendra
                agrees that DMT shall not be liable to the DMT Grahak Seva
                Kendra or any third party for any such termination or
                interruption. Any suspected fraudulent, abusive, or illegal
                activity may be referred to appropriate law enforcement
                authorities. These remedies are in addition to any other
                remedies DMT may have at law or in equity. Upon termination for
                any reason, DMT Grahak Seva Kendra agrees to immediately stop
                using the DMT Services and Platform.
              </p>
              <p class="service-content">
                <b>DISPUTE RESOLUTION AND ARBITRATION</b>
              </p>
              <ul>
                <li>
                  The Parties shall seek to resolve any dispute, controversy,
                  claim or breach arising out of or concerning this Agreement
                  including any dispute as to the existence or validity of this
                  Agreement, by amicable arrangement and compromise, and only if
                  the Parties fail to resolve the same by amicable arrangement
                  and compromise within 30 (thirty) days of receipt of written
                  notice of the same by the other Party.
                </li>
                <li>
                  Any dispute, controversy, claim or breach arising out of or
                  concerning this Agreement (including a dispute as to the
                  existence or validity hereof) shall be finally settled under
                  the Arbitration & Conciliation Act, 1996, then in effect which
                  shall be deemed to have been incorporated herein, by binding
                  arbitration by a sole arbitrator to be appointed by the
                  Parties jointly or by the company.
                </li>
                <li>
                  The arbitration award shall be final and binding upon the
                  Parties and shall be enforceable by the relevant courts,
                  competent to enforce the arbitration award. The arbitral award
                  shall be substantiated in writing and the arbitral tribunal
                  shall also have the right to decide on the costs of
                  arbitration proceedings.
                </li>
                <li>
                  This Agreement shall be governed by and construed under the
                  laws of India and the courts of New Delhi shall have exclusive
                  jurisdiction and the language of the arbitration shall be
                  English.
                </li>
              </ul>
              <p class="semi-bold-txt margin-top-x2 pb-sm-5">
                <b>
                  Thanking you for using <span class="dmt-D">D</span>
                  <span class="dmt-M">M</span>
                  <span class="dmt-T">T </span>
                     EMPIRE INDIA PRIVATE LIMITED
                </b>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Tncdmt;
